<template>
  <div class="info">
    <div class="info__content">
      <h1>Lidice</h1>
      <p>
        Projekt Lidice.online vychází z již hotové klikací mapy na
        stránkách&nbsp;
        <a
          class="link"
          rel="noopener noreferrer"
          target="_blank"
          href="http://www.lidice.cz/kultura_sport/udalosti/20130330%20Projekt%20-%20Klikac%C3%AD%20mapa%20Lidice%201942.html"
        >
          lidice.cz
        </a>
        ze které čerpá i veškerá data.
      </p>
      <p>
        Na tomto projektu mi chyběla možnost rychle vyhledávat v obyvatelích.
        Možnost filtrovat je dle věku, pohlaví nebo faktu že Lidický masakr
        přežili. Proto jsem vytvořil tyto stránky jako doplňek k již hotové
        klikací mapě.
      </p>
      <router-link class="btn btn-clear" to="/">
        Zobrazit osudy
      </router-link>
      <div>
        <small>
          Pokud najdete na stránkách nesrovnalosti nebo máte nápad jak je
          vylepšit napište mi prosím
          <a class="link" href="mailto:jaroslavhorak@gmail.com">
            zde
          </a>.
        </small>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>

<style scoped>
.info {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.info__content {
  max-width: 40rem;
  text-align: center;
  width: 100%;
  padding: 1rem;
}

.info__content p {
  font-size: 14px;
  line-height: 1.5;
}

.info__content .btn {
  margin-bottom: 1rem;
}

.info h1 {
  font-size: 4rem;
  margin-bottom: 0.15em;
  margin-top: 0;
  letter-spacing: 0.018em;
  background-color: var(--colorPrimary);
  display: inline-block;
  line-height: 1.5;
  padding: 0 3rem;
  color: var(--colorWhite);
  text-transform: uppercase;
}

@media (min-width: 992px) {
  .info h1 {
    font-size: 7rem;
  }
  .info__content p {
    font-size: 18px;
  }
}
</style>